var _path, _path2, _path3, _path4, _polygon, _rect, _path5, _rect2, _rect3, _rect4, _rect5, _rect6, _circle, _circle2, _circle3, _circle4, _path6, _circle5, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _path20, _path21, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _circle15, _path22, _path23, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _ellipse12, _circle16, _path24, _path25, _ellipse13, _ellipse14, _ellipse15, _ellipse16, _ellipse17, _ellipse18, _circle17, _path26, _path27, _ellipse19, _ellipse20, _ellipse21, _ellipse22, _ellipse23, _ellipse24, _circle18, _path28, _path29, _ellipse25, _ellipse26, _ellipse27, _ellipse28, _ellipse29, _ellipse30, _circle19, _path30, _path31, _ellipse31, _ellipse32, _ellipse33, _ellipse34, _ellipse35, _ellipse36, _circle20, _polygon2, _path32, _path33, _path34, _path35, _polygon3, _path36, _path37, _path38, _path39, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEatmore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 888,
    height: 485.489,
    viewBox: "0 0 888 485.489",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "breakfast") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M275.41211,460.30048H246.99329a3.76777,3.76777,0,0,0-3.76777,3.76776v12.47387a3.76777,3.76777,0,0,0,3.76777,3.76777h4.70941V499h19V480.30988h4.70941a3.76777,3.76777,0,0,0,3.76776-3.76777V464.06824A3.76777,3.76777,0,0,0,275.41211,460.30048Z",
    transform: "translate(-156 -207.2555)",
    fill: "#f5f5c6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M303.87661,574.46128a146.10549,146.10549,0,0,1-25.418-86.62437,3.08142,3.08142,0,0,0-2.40522-3.075V479.372H246.03933v5.315h-.41356a3.07971,3.07971,0,0,0-3.06724,3.30786q3.54683,49.44186-23.95358,88.677a8.4873,8.4873,0,0,0-1.53606,5.14352l3.28188,101.51817a8.78815,8.78815,0,0,0,8.713,8.48191h67.88732a8.79123,8.79123,0,0,0,8.71824-8.63152l1.26471-98.56588A17.78875,17.78875,0,0,0,303.87661,574.46128Z",
    transform: "translate(-156 -207.2555)",
    fill: "#3f3d56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M269.48783,464.36493a8.12881,8.12881,0,0,1-16.25763,0",
    transform: "translate(-156 -207.2555)",
    opacity: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M293.12991,608.18244h-8.22064a21.57614,21.57614,0,0,0-42.6488,0h-8.22118a6.06671,6.06671,0,0,0-5.99616,6.98918l8.92944,58.04135h51.27407l10.84608-57.84582A6.0667,6.0667,0,0,0,293.12991,608.18244Z",
    transform: "translate(-156 -207.2555)",
    fill: "#f5f5c6"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "827.952 307.634 825.98 386.448 823.538 484.181 740.414 484.181 737.552 369.675 736 307.634 827.952 307.634",
    fill: "#e6e6e6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 775.72312,
    y: 265.70393,
    width: 11.76981,
    height: 155.95002,
    fill: "#f5f5c6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M978.06676,574.27527l-2.22611,112.02H900.07391l-2.60826-131.24365a51.63393,51.63393,0,0,1,40.82688,5.61536C950.95161,568.15405,965.173,572.18424,978.06676,574.27527Z",
    transform: "translate(-156 -207.2555)",
    fill: "#3f3d56"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 752.03074,
    y: 379.63032,
    width: 10.79992,
    height: 10.79992,
    fill: "#e6e6e6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 759.38688,
    y: 357.56192,
    width: 10.79992,
    height: 10.79992,
    fill: "#e6e6e6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 936.42384,
    y: 575.81564,
    width: 10.79992,
    height: 10.79992,
    transform: "translate(375.57517 -653.92108) rotate(36.56259)",
    fill: "#e6e6e6"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 955.93676,
    y: 594.95132,
    width: 10.79992,
    height: 10.79992,
    transform: "translate(390.81432 -661.77916) rotate(36.56259)",
    fill: "#e6e6e6"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 922.83416,
    y: 605.98552,
    width: 10.79992,
    height: 10.79992,
    transform: "translate(390.87303 -639.88846) rotate(36.56259)",
    fill: "#e6e6e6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 805.14765,
    cy: 351.03508,
    r: 2.20684,
    fill: "#3f3d56"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 760.27524,
    cy: 336.32281,
    r: 2.20684,
    fill: "#3f3d56"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 797.79152,
    cy: 320.87493,
    r: 2.20684,
    fill: "#3f3d56"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 444.50808,
    cy: 241.75402,
    r: 241.75402,
    fill: "#f5f5c6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M600.50808,625.46663a176.45595,176.45595,0,1,1,124.77436-51.68275A175.30352,175.30352,0,0,1,600.50808,625.46663Zm0-342.0314c-91.29808,0-165.5743,74.27621-165.5743,165.57429,0,91.2977,74.27622,165.5743,165.5743,165.5743,91.2977,0,165.57429-74.2766,165.57429-165.5743C766.08237,357.71144,691.80578,283.43523,600.50808,283.43523Z",
    transform: "translate(-156 -207.2555)",
    opacity: 0.2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 444.50808,
    cy: 241.75402,
    r: 171.0157,
    fill: "#3f3d56"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M473.32742,380.62742a21.704,21.704,0,1,1,38.68118-19.69819l48.31632,94.87836a21.704,21.704,0,1,1-38.68118,19.69819Z",
    transform: "translate(-156 -207.2555)",
    fill: "#ff6584"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M478.71655,391.21l-2.23-4.379c11.12916-8.64736,24.19788-15.007,38.68118-19.69819l2.23,4.379C501.72232,374.77607,488.38616,380.817,478.71655,391.21Z",
    transform: "translate(-156 -207.2555)",
    opacity: 0.2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M489.12314,411.64534l-2.23-4.379c11.12915-8.64736,24.19788-15.007,38.68117-19.69819l2.23,4.379C512.12891,395.21141,498.79275,401.25236,489.12314,411.64534Z",
    transform: "translate(-156 -207.2555)",
    opacity: 0.2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M499.52973,432.08068l-2.23-4.379c11.12915-8.64736,24.19788-15.007,38.68118-19.69819l2.23,4.379C522.5355,415.64675,509.19935,421.6877,499.52973,432.08068Z",
    transform: "translate(-156 -207.2555)",
    opacity: 0.2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M509.93632,452.516l-2.23-4.379c11.12916-8.64736,24.19788-15.007,38.68118-19.69819l2.23,4.379C532.94209,436.08209,519.60594,442.123,509.93632,452.516Z",
    transform: "translate(-156 -207.2555)",
    opacity: 0.2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M520.34292,472.95136l-2.23-4.379c11.12916-8.64736,24.19788-15.007,38.68118-19.69819l2.23,4.379C543.34868,456.51743,530.01253,462.55838,520.34292,472.95136Z",
    transform: "translate(-156 -207.2555)",
    opacity: 0.2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M437.07906,416.14643a21.704,21.704,0,1,1,38.68118-19.6982l48.31632,94.87837a21.704,21.704,0,0,1-38.68118,19.69819Z",
    transform: "translate(-156 -207.2555)",
    fill: "#ff6584"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M442.46819,426.729l-2.23-4.379c11.12916-8.64736,24.19788-15.007,38.68118-19.69819l2.23,4.379C465.474,410.29508,452.1378,416.336,442.46819,426.729Z",
    transform: "translate(-156 -207.2555)",
    opacity: 0.2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M452.87478,447.16435l-2.23-4.379c11.12915-8.64736,24.19788-15.007,38.68118-19.69819l2.23,4.379C475.88055,430.73042,462.5444,436.77137,452.87478,447.16435Z",
    transform: "translate(-156 -207.2555)",
    opacity: 0.2
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M463.28137,467.59969l-2.23-4.379c11.12915-8.64736,24.19788-15.007,38.68118-19.69819l2.23,4.379C486.28714,451.16576,472.951,457.20671,463.28137,467.59969Z",
    transform: "translate(-156 -207.2555)",
    opacity: 0.2
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M473.688,488.035l-2.23-4.379c11.12916-8.64736,24.19788-15.007,38.68118-19.69819l2.23,4.379C496.69373,471.6011,483.35758,477.64205,473.688,488.035Z",
    transform: "translate(-156 -207.2555)",
    opacity: 0.2
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M484.09456,508.47037l-2.23-4.379c11.12916-8.64736,24.19788-15.007,38.68118-19.69819l2.23,4.379C507.10032,492.03644,493.76417,498.07739,484.09456,508.47037Z",
    transform: "translate(-156 -207.2555)",
    opacity: 0.2
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M714.77766,454.45093l.15257.00013a25.8881,25.8881,0,0,0,24.23924-16.23619,84.50284,84.50284,0,0,0,5.9231-31.69393c-.27144-45.91073-37.62223-83.57515-83.52936-84.21021a84.74394,84.74394,0,0,0-35.27687,162.32018,25.66668,25.66668,0,0,0,28.50566-5.28585A84.45815,84.45815,0,0,1,714.77766,454.45093Z",
    transform: "translate(-156 -207.2555)",
    fill: "#e6e6e6"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 515.24639,
    cy: 193.55868,
    r: 27.98439,
    fill: "#f9a825"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 454.42624,
    cy: 187.11516,
    r: 3.29669,
    fill: "#3f3d56"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 345.59806,
    cy: 190.22453,
    r: 3.29669,
    fill: "#3f3d56"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 471.99609,
    cy: 152.94948,
    r: 3.29669,
    fill: "#3f3d56"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 471.90243,
    cy: 247.97277,
    r: 3.29669,
    fill: "#3f3d56"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 537.19934,
    cy: 146.14069,
    r: 3.29669,
    fill: "#3f3d56"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 324.20705,
    cy: 236.31261,
    r: 3.29669,
    fill: "#3f3d56"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 348.30472,
    cy: 283.7306,
    r: 3.29669,
    fill: "#3f3d56"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 499.69951,
    cy: 289.94935,
    r: 12.43751,
    fill: "#ff6584"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M665.02764,497.9822a9.32813,9.32813,0,0,1-18.65626,0",
    transform: "translate(-156 -207.2555)",
    opacity: 0.2
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M646.37138,496.42751a9.32813,9.32813,0,0,1,18.65626,0",
    transform: "translate(-156 -207.2555)",
    opacity: 0.2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 495.03545,
    cy: 285.67396,
    rx: 0.77734,
    ry: 1.16602,
    fill: "#ff6584"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 499.69951,
    cy: 284.11927,
    rx: 0.77734,
    ry: 1.16602,
    fill: "#ff6584"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 499.69951,
    cy: 294.22475,
    rx: 0.77734,
    ry: 1.16602,
    fill: "#ff6584"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 504.36357,
    cy: 288.00599,
    rx: 0.77734,
    ry: 1.16602,
    fill: "#ff6584"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 503.58623,
    cy: 296.55678,
    rx: 0.77734,
    ry: 1.16602,
    fill: "#ff6584"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 494.2581,
    cy: 292.67006,
    rx: 0.77734,
    ry: 1.16602,
    fill: "#ff6584"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 524.57452,
    cy: 256.52356,
    r: 12.43751,
    fill: "#ff6584"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M689.90265,464.5564a9.32813,9.32813,0,0,1-18.65626,0",
    transform: "translate(-156 -207.2555)",
    opacity: 0.2
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M671.24639,463.00172a9.32813,9.32813,0,0,1,18.65626,0",
    transform: "translate(-156 -207.2555)",
    opacity: 0.2
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 519.91046,
    cy: 252.24816,
    rx: 0.77734,
    ry: 1.16602,
    fill: "#ff6584"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 524.57452,
    cy: 250.69348,
    rx: 0.77734,
    ry: 1.16602,
    fill: "#ff6584"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 524.57452,
    cy: 260.79895,
    rx: 0.77734,
    ry: 1.16602,
    fill: "#ff6584"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 529.23859,
    cy: 254.5802,
    rx: 0.77734,
    ry: 1.16602,
    fill: "#ff6584"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 528.46124,
    cy: 263.13098,
    rx: 0.77734,
    ry: 1.16602,
    fill: "#ff6584"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 519.13311,
    cy: 259.24426,
    rx: 0.77734,
    ry: 1.16602,
    fill: "#ff6584"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 549.44953,
    cy: 273.62513,
    r: 12.43751,
    fill: "#f5f5c6"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M714.77766,481.658a9.32813,9.32813,0,0,1-18.65626,0",
    transform: "translate(-156 -207.2555)",
    opacity: 0.2
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M696.1214,480.10329a9.32813,9.32813,0,0,1,18.65626,0",
    transform: "translate(-156 -207.2555)",
    opacity: 0.2
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 544.78547,
    cy: 269.34974,
    rx: 0.77734,
    ry: 1.16602,
    fill: "#f5f5c6"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 549.44953,
    cy: 267.79505,
    rx: 0.77734,
    ry: 1.16602,
    fill: "#f5f5c6"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 549.44953,
    cy: 277.90052,
    rx: 0.77734,
    ry: 1.16602,
    fill: "#f5f5c6"
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 554.1136,
    cy: 271.68177,
    rx: 0.77734,
    ry: 1.16602,
    fill: "#f5f5c6"
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 553.33625,
    cy: 280.23255,
    rx: 0.77734,
    ry: 1.16602,
    fill: "#f5f5c6"
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 544.00812,
    cy: 276.34583,
    rx: 0.77734,
    ry: 1.16602,
    fill: "#f5f5c6"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 487.262,
    cy: 275.17982,
    r: 12.43751,
    fill: "#f5f5c6"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M652.59013,483.21266a9.32813,9.32813,0,0,1-18.65626,0",
    transform: "translate(-156 -207.2555)",
    opacity: 0.2
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M633.93387,481.658a9.32813,9.32813,0,0,1,18.65626,0",
    transform: "translate(-156 -207.2555)",
    opacity: 0.2
  })), _ellipse19 || (_ellipse19 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 482.59794,
    cy: 270.90442,
    rx: 0.77734,
    ry: 1.16602,
    fill: "#f5f5c6"
  })), _ellipse20 || (_ellipse20 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 487.262,
    cy: 269.34974,
    rx: 0.77734,
    ry: 1.16602,
    fill: "#f5f5c6"
  })), _ellipse21 || (_ellipse21 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 487.262,
    cy: 279.45521,
    rx: 0.77734,
    ry: 1.16602,
    fill: "#f5f5c6"
  })), _ellipse22 || (_ellipse22 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 491.92607,
    cy: 273.23646,
    rx: 0.77734,
    ry: 1.16602,
    fill: "#f5f5c6"
  })), _ellipse23 || (_ellipse23 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 491.14872,
    cy: 281.78724,
    rx: 0.77734,
    ry: 1.16602,
    fill: "#f5f5c6"
  })), _ellipse24 || (_ellipse24 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 481.8206,
    cy: 277.90052,
    rx: 0.77734,
    ry: 1.16602,
    fill: "#f5f5c6"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 515.24639,
    cy: 280.62122,
    r: 12.43751,
    fill: "#f5f5c6"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M680.57452,488.65407a9.32813,9.32813,0,1,1-18.65626,0",
    transform: "translate(-156 -207.2555)",
    opacity: 0.2
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M661.91826,487.09938a9.32813,9.32813,0,1,1,18.65626,0",
    transform: "translate(-156 -207.2555)",
    opacity: 0.2
  })), _ellipse25 || (_ellipse25 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 510.58233,
    cy: 276.34583,
    rx: 0.77734,
    ry: 1.16602,
    fill: "#f5f5c6"
  })), _ellipse26 || (_ellipse26 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 515.24639,
    cy: 274.79114,
    rx: 0.77734,
    ry: 1.16602,
    fill: "#f5f5c6"
  })), _ellipse27 || (_ellipse27 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 515.24639,
    cy: 284.89662,
    rx: 0.77734,
    ry: 1.16602,
    fill: "#f5f5c6"
  })), _ellipse28 || (_ellipse28 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 519.91046,
    cy: 278.67786,
    rx: 0.77734,
    ry: 1.16602,
    fill: "#f5f5c6"
  })), _ellipse29 || (_ellipse29 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 519.13311,
    cy: 287.22865,
    rx: 0.77734,
    ry: 1.16602,
    fill: "#f5f5c6"
  })), _ellipse30 || (_ellipse30 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 509.80498,
    cy: 283.34193,
    rx: 0.77734,
    ry: 1.16602,
    fill: "#f5f5c6"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 534.68,
    cy: 293.83607,
    r: 12.43751,
    fill: "#ff6584"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M700.00812,501.86892a9.32812,9.32812,0,1,1-18.65625,0",
    transform: "translate(-156 -207.2555)",
    opacity: 0.2
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M681.35187,500.31423a9.32812,9.32812,0,1,1,18.65625,0",
    transform: "translate(-156 -207.2555)",
    opacity: 0.2
  })), _ellipse31 || (_ellipse31 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 530.01593,
    cy: 289.56068,
    rx: 0.77734,
    ry: 1.16602,
    fill: "#ff6584"
  })), _ellipse32 || (_ellipse32 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 534.68,
    cy: 288.00599,
    rx: 0.77734,
    ry: 1.16602,
    fill: "#ff6584"
  })), _ellipse33 || (_ellipse33 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 534.68,
    cy: 298.11147,
    rx: 0.77734,
    ry: 1.16602,
    fill: "#ff6584"
  })), _ellipse34 || (_ellipse34 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 539.34406,
    cy: 291.89271,
    rx: 0.77734,
    ry: 1.16602,
    fill: "#ff6584"
  })), _ellipse35 || (_ellipse35 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 538.56672,
    cy: 300.4435,
    rx: 0.77734,
    ry: 1.16602,
    fill: "#ff6584"
  })), _ellipse36 || (_ellipse36 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 529.23859,
    cy: 296.55678,
    rx: 0.77734,
    ry: 1.16602,
    fill: "#ff6584"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 374.73442,
    cy: 246.41808,
    r: 3.29669,
    fill: "#3f3d56"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "464.345 366.08 385.17 344.123 388.203 332.857 467.378 354.815 464.345 366.08",
    fill: "#f9a825"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M608.73806,569.57043a218.26828,218.26828,0,0,1-82.07767,0V557.89212a250.99129,250.99129,0,0,0,82.07767,0Z",
    transform: "translate(-156 -207.2555)",
    fill: "#f9a825"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M617.17595,534.53552a218.26828,218.26828,0,0,1-82.07767,0V522.85721a250.99184,250.99184,0,0,0,82.07767,0Z",
    transform: "translate(-156 -207.2555)",
    fill: "#f9a825"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M645.558,548.54948a218.26833,218.26833,0,0,1-82.07768,0v-11.6783a250.9919,250.9919,0,0,0,82.07768,0Z",
    transform: "translate(-156 -207.2555)",
    fill: "#f9a825"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M652.46168,561.78489a218.26787,218.26787,0,0,1-82.07767,0v-11.6783a250.99184,250.99184,0,0,0,82.07767,0Z",
    transform: "translate(-156 -207.2555)",
    fill: "#f9a825"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "520.531 371.824 439.554 385.426 437.676 373.904 518.652 360.302 520.531 371.824",
    fill: "#f9a825"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M664.43494,580.57677a219.97,219.97,0,0,1-74.58008,34.78439l-4.80446-10.61152a252.95437,252.95437,0,0,0,74.58007-34.78439Z",
    transform: "translate(-156 -207.2555)",
    fill: "#f9a825"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M657.68866,545.16625a219.96991,219.96991,0,0,1-74.58007,34.78439l-4.80446-10.61152a252.95437,252.95437,0,0,0,74.58007-34.78439Z",
    transform: "translate(-156 -207.2555)",
    fill: "#f9a825"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M689.24339,545.87182a219.96977,219.96977,0,0,1-74.58008,34.78439l-4.80446-10.61151a252.95471,252.95471,0,0,0,74.58008-34.7844Z",
    transform: "translate(-156 -207.2555)",
    fill: "#f9a825"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M700.96153,554.97242a219.96991,219.96991,0,0,1-74.58007,34.78439L621.577,579.14529a252.95437,252.95437,0,0,0,74.58007-34.78439Z",
    transform: "translate(-156 -207.2555)",
    fill: "#f9a825"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 442.95339,
    y: 324.92984,
    width: 3.88672,
    height: 3.88672,
    fill: "#00bf71"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 454.61355,
    y: 392.55878,
    width: 3.88672,
    height: 3.88672,
    fill: "#00bf71"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 392.42602,
    y: 324.92984,
    width: 3.88672,
    height: 3.88672,
    fill: "#00bf71"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 482.59794,
    y: 373.12517,
    width: 3.88672,
    height: 3.88672,
    fill: "#00bf71"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 484.92997,
    y: 350.5822,
    width: 3.88672,
    height: 3.88672,
    fill: "#00bf71"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 574.85572,
    y: 545.40019,
    width: 5.44141,
    height: 3.10938,
    transform: "translate(250.70796 -437.19066) rotate(34.15572)",
    fill: "#00bf71"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 620.71902,
    y: 553.95098,
    width: 5.44141,
    height: 3.10938,
    transform: "translate(263.41949 -461.46545) rotate(34.15572)",
    fill: "#00bf71"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 564.75025,
    y: 568.72051,
    width: 5.44141,
    height: 3.10938,
    transform: "translate(262.05797 -427.49459) rotate(34.15572)",
    fill: "#00bf71"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 596.62136,
    y: 565.61114,
    width: 5.44141,
    height: 3.10938,
    transform: "translate(1249.17714 182.37779) rotate(124.15572)",
    fill: "#00bf71"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 617.60965,
    y: 571.05255,
    width: 5.44141,
    height: 3.10938,
    transform: "translate(1286.45203 173.50612) rotate(124.15572)",
    fill: "#00bf71"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 673.57842,
    y: 552.39629,
    width: 5.44141,
    height: 3.10938,
    transform: "matrix(-0.56144, 0.82751, -0.82751, -0.56144, 1358.40581, 98.06043)",
    fill: "#00bf71"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    y: 483.24828,
    width: 888,
    height: 2.24072,
    fill: "#3f3d56"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEatmore);
export default __webpack_public_path__ + "static/media/eatmore.b7e826b8947e9625c4774b9e0c8748cb.svg";
export { ForwardRef as ReactComponent };